<!-- IF YOU PASS IMAGE THUMBNAIL, BUT NOT TITLE, THEN DISPLAY THIS -->

<div *ngIf="imageMode || imageThumbnail" class="card my-5 p-3">
	<div class="flex gap-4">
		<!-- Thumbnail (has image) with hover overlay -->
		<div
			*ngIf="imageThumbnail"
			class="image-preview-container"
			(mouseenter)="showPreview = true"
			(mouseleave)="showPreview = false"
		>
			<img
				[src]="imageThumbnail || defaultImage"
				alt="Thumbnail"
				class="thumbnail"
				(error)="onImageError($event)"
			/>

			<!-- Hover overlay → replace image -->
			<div class="image-action-overlay" (click)="imageAction.emit()" title="Replace image">
				<i class="pi pi-camera"></i>
				<span>Replace</span>
			</div>

			<!-- Full image popup -->
			<div class="full-image-popup" *ngIf="showPreview">
				<h4 class="item-name-header">{{ itemName | titlecase }}</h4>
				<img [src]="imageThumbnail || defaultImage" alt="Full Image" (error)="onImageError($event)" />
			</div>
		</div>

		<!-- Dashed placeholder (no image) → upload image -->
		<div
			*ngIf="!imageThumbnail"
			class="image-upload-placeholder"
			(click)="imageAction.emit()"
			title="Upload image"
		>
			<i class="pi pi-plus"></i>
			<span>Upload</span>
		</div>

		<!-- Right Section -->
		<div class="flex flex-column flex-grow-1 w-full">
			<!-- Row 1: Title -->
			<div class="flex justify-content-between align-items-center mb-2">
				<h3 class="m-0">{{ itemName }}</h3>

				<div class="flex align-items-center gap-2">
					<ng-container *ngIf="!hideButton && !showDropdown">
						<p-button
							[label]="buttonLabel"
							(onClick)="buttonClick.emit()"
							[icon]="'pi ' + buttonIcon"
							[text]="true"
							[iconPos]="'left'"
						/>
					</ng-container>

					<ng-container *ngIf="showDropdown && itemActionMenu.length">
						<div class="relative-button-wrapper" style="position: relative; display: inline-block">
							<p-button
								type="button"
								label="Actions"
								icon="pi pi-chevron-down"
								(click)="menu.toggle($event)"
							></p-button>
							<p-menu
								#menu
								[popup]="true"
								[model]="itemActionMenu"
								appendTo="body"
								baseZIndex="1000"
							></p-menu>
						</div>
					</ng-container>
				</div>
			</div>

			<!-- Row 2: Headers -->
			<div class="grid text-sm font-semibold text-color-secondary mb-1">
				<div *ngFor="let key of keys" class="col">
					{{ labels[key].text === 'ID' ? 'Item ID' : labels[key].text || key }}
				</div>
			</div>

			<!-- Row 3: Values -->
			<div class="grid text-base">
				<div *ngFor="let key of keys" class="col">
					<ng-container *ngIf="labels[key]?.pipe; else plainValue">
						{{ info[key] | dynamicPipe: labels[key].pipe || '' }}
					</ng-container>
					<ng-template #plainValue>{{ displayValue(info[key]) }}</ng-template>
				</div>
			</div>
		</div>
	</div>

	<!-- Custom Content -->
	<div class="custom-content mt-3">
		<ng-content></ng-content>
	</div>
</div>

<!-- IF YOU PASS TITLE BUT NOT IMAGE THUMBNAIL DISPLAY THIS -->

<div *ngIf="title" class="card my-5">
	<div class="flex justify-content-between">
		<h5>{{ title }}</h5>
		<div class="flex align-items-center gap-2">
			<ng-content select="[card-actions]"></ng-content>
			<ng-container *ngIf="!hideButton && !showDropdown">
				<p-button
					[label]="buttonLabel"
					(onClick)="buttonClick.emit()"
					[icon]="'pi ' + buttonIcon"
					[text]="true"
					[iconPos]="'left'"
				/>
			</ng-container>

			<ng-container *ngIf="showDropdown && itemActionMenu.length">
				<div class="relative-button-wrapper" style="position: relative; display: inline-block">
					<p-button
						type="button"
						label="Actions"
						icon="pi pi-chevron-down"
						(click)="menu.toggle($event)"
					></p-button>
					<p-menu #menu [popup]="true" [model]="itemActionMenu" appendTo="body" baseZIndex="1000"></p-menu>
				</div>
			</ng-container>
		</div>
	</div>

	<div
		class="basic-info-container"
		[ngClass]="layout"
		[style.grid-template-columns]="layout === 'grid' ? gridColumnsStyle : null"
	>
		<!-- Handle info as an object -->
		<ng-container *ngIf="!isArray(info); else arrayTemplate">
			<div *ngFor="let key of keys" class="info-item" [ngClass]="layout">
				<p class="font-bold">{{ labels[key].text || key }}</p>
				<p>
					<ng-container *ngIf="labels[key]?.pipe; else plainValue">
						{{ info[key] | dynamicPipe: labels[key].pipe || '' }}
					</ng-container>
					<ng-template #plainValue>{{ displayValue(info[key]) }}</ng-template>
				</p>
			</div>
		</ng-container>

		<!-- Handle info as an array -->
		<ng-template #arrayTemplate>
			<div *ngFor="let item of info; let i = index" class="info-array-item" [ngClass]="layout">
				<div *ngFor="let key of keys" class="info-item">
					<p class="font-bold">{{ labels[key].text || key }}</p>
					<p>
						<ng-container *ngIf="labels[key]?.pipe; else plainArrayValue">
							{{ item[key] | dynamicPipe: labels[key].pipe || '' }}
						</ng-container>
						<ng-template #plainArrayValue>{{ displayValue(item[key]) }}</ng-template>
					</p>
				</div>
			</div>
		</ng-template>

		<!-- Display additional properties not part of the info object -->
		<div *ngFor="let key of extraProps | keyvalue" class="info-item">
			<p class="font-bold">{{ labels[key.key].text || key.key }}</p>
			<p>
				<ng-container *ngIf="labels[key.key]?.pipe; else plainExtraValue">
					{{ key.value | dynamicPipe: labels[key.key].pipe || '' }}
				</ng-container>
				<ng-template #plainExtraValue>{{ displayValue(key.value) }}</ng-template>
			</p>
		</div>
	</div>

	<!-- Slot for additional custom content -->
	<div class="custom-content">
		<ng-content></ng-content>
	</div>
</div>
